import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { gamesApi } from '../features/games/api/gamesApi';
import { modsApi } from '../features/mods/api/modsApi';
import { localeReducer } from './localeSlice';

export const store = configureStore({
  reducer: {
    locale: localeReducer,
    [modsApi.reducerPath]: modsApi.reducer,
    [gamesApi.reducerPath]: gamesApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(modsApi.middleware, gamesApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
